export const jobStatusViewModalStyles = {
  header: {
    mb: 2.5,
    textAlign: 'center',
    position: 'relative',
  },
  jobTitle: {
    mb: 1,
    fontWeight: 700,
    color: 'text.primary',
    fontSize: '1.25rem',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  divider: {
    mb: 2,
    borderColor: 'divider',
    borderWidth: 1,
    background: 'linear-gradient(90deg, transparent 0%, #e0e0e0 50%, transparent 100%)',
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.2,
  },
  detailRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    py: 1,
    px: 1.5,
    borderRadius: 2,
    backgroundColor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'action.hover',
      borderColor: 'primary.main',
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
  },
  detailRowWithDescription: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1.5,
    py: 1,
    px: 1.5,
    borderRadius: 2,
    backgroundColor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'action.hover',
      borderColor: 'primary.main',
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
  },
  label: {
    minWidth: 140,
    fontWeight: 600,
    color: 'text.secondary',
    fontSize: '0.8rem',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    '&::before': {
      content: '""',
      width: 4,
      height: 4,
      borderRadius: '50%',
      backgroundColor: 'primary.main',
      display: 'inline-block',
    },
  },
  value: {
    color: 'text.primary',
    fontSize: '0.9rem',
    fontWeight: 500,
  },
  statusChip: {
    fontWeight: 700,
    fontSize: '0.75rem',
    height: 28,
    minWidth: 90,
    borderRadius: 14,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  statusValueBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 0.25,
  },
  lastChanged: {
    color: 'text.secondary',
    fontSize: '0.7rem',
    fontStyle: 'italic',
  },
  descriptionValue: {
    color: 'text.primary',
    fontSize: '0.9rem',
    lineHeight: 1.5,
    fontWeight: 400,
    fontStyle: 'italic',
  },
};
